import FormItemWrapper from './form-item-wrapper'
import { mapSlots } from '../../../plugins/element-ui/component'

export default {
  name: 'VsFormItem',
  functional: true,
  props: {
    ...FormItemWrapper.props,
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    help: {
      type: String,
      default: null
    }
  },
  render(h, { data, children, slots, props }) {
    const { attrs, ...itemData } = data
    const { title, description, ...itemProps } = props

    itemData.props = itemProps
    itemData.attrs = { margin: 0, ...attrs }

    const content = []
    const items = []

    if (title) {
      items.push(h('h3', {}, [title]))
    }

    if (description) {
      items.push(h('p', {}, [description]))
    }

    if (items.length) {
      const stackData = { props: { gap: '2xs' }, attrs: { marginBottom: 'sm' } }
      content.push(h('vs-stack', stackData, items))
    }

    content.push(...children)
    content.push(mapSlots(h, slots))

    return h(FormItemWrapper, itemData, content)
  }
}
